export default __webpack_public_path__ + "static/media/2021.f2b87f3d.png";